import { roundToDecimal } from 'src/utils/math';

export default function roundPortfolioTradeValue(value: number | undefined) {
	if (value === undefined) {
		return 0;
	}

	return roundToDecimal(value, 2);
}
